import { signInWithCustomToken, signOut, type Auth } from "firebase/auth";
import { decodeJwt } from "jose";

/**
 * Signs in as the person a Firebase custom token names. A custom token
 * carries its `uid` in the clear, so the app can tell whether it already
 * holds that person's session (keep it; nothing to redo) or somebody else's
 * (sign out first: the token's holder proved themselves on the web moments
 * ago, and the account this device happened to hold did not). The account
 * being left sends its plays first, while it is still signed in.
 */
export async function signInAs(
  customToken: string,
  {
    auth,
    reporting,
  }: { auth: Auth; reporting: { flushPlaysBeforeLogout(): Promise<void> } },
): Promise<void> {
  const current = auth.currentUser;
  if (current) {
    let uid: unknown;
    try {
      uid = decodeJwt(customToken).uid;
    } catch {
      uid = undefined;
    }
    if (uid === current.uid) return;
    await reporting.flushPlaysBeforeLogout();
    await signOut(auth);
  }
  await signInWithCustomToken(auth, customToken);
}
